import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=d9ddb592"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=d9ddb592&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/viparabclub/releases/20251208210823/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9ddb592')) {
      api.createRecord('d9ddb592', component.options)
    } else {
      api.reload('d9ddb592', component.options)
    }
    module.hot.accept("./TheFooter.vue?vue&type=template&id=d9ddb592", function () {
      api.rerender('d9ddb592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/TheFooter.vue"
export default component.exports